import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { MissionSection } from './components/MissionSection';
import { VisionSection } from './components/VisionSection';
import { UniqueSection } from './components/UniqueSection';
import { AudienceSection } from './components/AudienceSection';
import { ValuesSection } from './components/ValuesSection';
import { WhySection } from './components/WhySection';
import { CTASection } from './components/CTASection';
import { Header } from '../home/components/Header';
import { Footer } from '../home/components/Footer';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header />
      <HeroSection />
      <MissionSection />
      <VisionSection />
      <UniqueSection />
      <AudienceSection />
      <ValuesSection />
      <WhySection />
      <CTASection />
      <Footer />
    </div>
  );
}
